export function createEntityState<T>(): EntityState<T> {
  return {
    isLoading: false,
    documents: undefined,
    error: undefined,
  };
}
